import { render, staticRenderFns } from "./invite-driver.vue?vue&type=template&id=48d1a2d8&scoped=true&"
import script from "./invite-driver.vue?vue&type=script&lang=js&"
export * from "./invite-driver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d1a2d8",
  null
  
)

export default component.exports